import { FC, useMemo } from "react";
import { useProductTableQuery } from "./hooks/useProductTableQuery";
import { ProductsTable } from "../ProductsTable/ProductsTable";
import { useProductCatalogContext } from "../ProductCatalogContext";

interface Props {
  attributeId: number;
  attributeName: string;
}

export const AttributeProductTable: FC<Props> = (props) => {
  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();

  const { loading, products } = useProductTableQuery(
    props.attributeId,
    localizeInstalls,
    entityTypeFilterValue
  );

  const queryResults = useMemo(() => {
    return products.map((product) => {
      return {
        id: product.id,
        name: product.name,
      };
    });
  }, [products]);

  return (
    <ProductsTable
      id="products-table"
      text={`Products related to ${props.attributeName}`}
      products={queryResults}
      isLoading={loading}
    />
  );
};
